<template>
  <!-- MODAL GraphATS -->
  <b-modal
    id="modalGraphATS"
    size="xl"
    title="Graph ATS Control"
    ok-only
    @hidden="resetModal"
  >
    <b-row>
      <b-col cols="12">
        <app-echart-line :option-data="option" />
      </b-col>

    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol,
  // BFormFile,
} from 'bootstrap-vue'
import AppEchartLine from '@core/components/charts/echart/AppEchartLine.vue'

export default {
  components: {
    BRow,
    BCol,
    AppEchartLine,

  },
  data() {
    return {
      editData: {
        id: '',
        devtype: '',
        devbrand: '',
        devmodel: '',
        // icon: '',
      },
      selectedID: '',
      selectedFile: null,
      option: {
        xAxisData: [],
        yAxisData: ['Main', 'Gen', 'AbNormal'],
        series: [
          {
            type: 'line',
            stack: 'Total',
            color: '#009F28 ',
            data: [],
            symbol: 'none',
          },
        ],
      },
    }
  },
  mounted() {
  },
  methods: {
    resetModal() {
      this.option.series[0].data = []
      this.option.xAxisData = []
    },
    graphModalATS(devid) {
      this.selectedID = devid
      axios.post('/get-graphATS', { devid: this.selectedID }).then(response => {
        this.xAxisData = []
        this.xAxisData = response.data
        this.xAxisData.forEach(value => {
          this.option.xAxisData.push(value.PeriodName)
          this.option.series[0].data.push(value.Status)
        })
      })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>

</style>
